// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__V3QC8","right":"styles_right__2SD2s"};